import PresentersEvents from "./PresentersEvents";
import { UserData } from "../../user/User";
import { FilterResult, UserFilter } from "./models/UserFilter";

export const loadAll = () =>
  ({
    type: PresentersEvents.LoadAll,
  } as const);

export const loadAllComplete = (users: UserData[]) =>
  ({
    type: PresentersEvents.LoadAllComplete,
    users,
  } as const);

export const load = (id: number) =>
  ({
    type: PresentersEvents.Load,
    id,
  } as const);

export const loadComplete = (userInfo: UserData) =>
  ({
    type: PresentersEvents.LoadComplete,
    userInfo,
  } as const);

export const filterUserList = (filters: UserFilter) =>
  ({
    type: PresentersEvents.filterUserListStarted,
    filters,
  } as const);

export const filterUserListComplete = (filterResult: FilterResult) =>
  ({
    type: PresentersEvents.filterUserListComplete,
    filterResult,
  } as const);
